import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    name: '4 April 2020',
    address: {
      country: 'Dinas',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Awan',
    phone: 'Toyota',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '4 April 2020',
    address: {
      country: 'Ekpedisi',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Tiara',
    phone: 'Daihatsu',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '5 April 2020',
    address: {
      country: 'Ekpedisi',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Dimitri',
    phone: 'Toyota',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '6 April 2020',
    address: {
      country: 'Dinas',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Dimitri',
    phone: 'Suzuki',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '6 April 2020',
    address: {
      country: 'Ekpedisi',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Awan',
    phone: 'Suzuki',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '7 April 2020',
    address: {
      country: 'Ekpedisi',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Tiara',
    phone: 'Toyota',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '8 April 2020',
    address: {
      country: 'Dinas',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Tiara',
    phone: 'Toyota',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '9 April 2020',
    address: {
      country: 'Dinas',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Dimitri',
    phone: 'Toyota',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '10 April 2020',
    address: {
      country: 'Dinas',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Dimitri',
    phone: 'Suzuki',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
  {
    id: uuid(),
    name: '10 April 2020',
    address: {
      country: 'Ekpedisi',
      state: '',
      city: '',
      street: '2849 Fulton Street'
    },
    email: 'Awan',
    phone: 'Suzuki',
    avatarUrl: '/images/avatars/avatar_3.png',
    createdAt: 1555016400000
  },
];
